import React from "react";
import { Link } from "react-router-dom";
import kid15 from "../assets/kid15.png";
import kid16 from "../assets/kid16.png";
import kid17 from "../assets/kid17.png";
import viewBlog from "../assets/viewblog.png";
import "./Home.css"; // put styles here
import API_CONFIG from "../config/api";

const blogPosts = [
  {
    id: "topskilldevelopment",
    img: "Polymath-images/Homepage/Blog/Frame 94.png",
    title: "Top Skills Kids Develop in Online Math Olympiads",
    date: "3 April 2025",
    excerpt:
      "In a world where critical thinking and problem-solving are more valuable than ever, Math Olympiads are emerging as a powerful tool for...",
  },
  {
    id: "onlineSummercampsareimportant",
    img: "Polymath-images/Homepage/Blog/Frame 95.png",
    title: "Why Online Summer Camps are Important for 21st-Century Kids",
    date: "3 April 2025",
    excerpt:
      "Learning to code does more than just teach a child how to build websites or apps. It fosters problem-solving skills...",
  },
  {
    id: "howtomanageyourtimewhpngileonlinelearning",
    img: "Polymath-images/Homepage/Blog/Frame 95-1.png",
    title: "How to manage your time while online learning",
    date: "3 April 2025",
    excerpt:
      "At Polymath-Kids, we take pride in the success of our students. From mastering coding to learning how to...",
  },
];

const FeaturedBlogs = () => {
  return (
    <section className="featured-blogs-section">
      <div className="container">
        {/* Title */}
        <h2 className="featured-blogs-title">
          <span className="featured-blog">Featured Blog</span>{" "}
          <span className="featured-posts">Posts</span>
        </h2>

        {/* Blog Grid */}
        <div className="blog-posts-grid">
          {blogPosts.map((post) => (
            <div className="blog-post-card" key={post.id}>
              <div className="blog-post-image">
                <img src={`${API_CONFIG.IMAGES_URL}/${post.img}`} alt={post.alt} />
              </div>
              <div className="blog-post-content">
                <div className="blog-post-date">{post.date}</div>
                <h3 className="blog-post-title">{post.title}</h3>
                <p className="blog-post-excerpt">{post.excerpt}</p>
              </div>
            </div>
          ))}
        </div>

        {/* View All Button */}
        <div className="view-all-blogs">
          <Link to="/blogs">
            <img src={viewBlog} alt="View All Blogs" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedBlogs;
